var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.292 68.205a1 1 0 0 0 1.415 1.414l28.322-28.352 28.265 28.351a1 1 0 0 0 1.416-1.412L41.443 39.852 69.56 11.708a1 1 0 1 0-1.415-1.413L40.03 38.436l-28.055-28.14a1 1 0 1 0-1.416 1.412l28.057 28.143z"
  })));
};
export default SvgClose;